import { useContext, useEffect, useState } from "react";

import { ComponentSpinner } from "../spinner";
import DataTable from "react-data-table-component";
import ErrorBoundaryWrapper from "@views/common/error-boundary-wrapper";
// ** Custom Components
import { NoDataComponent } from "../no-data-component";
import Paginate from "@components/ui-components/paginate";
// ** Constants
import { ROW_PER_PAGINATION_OPTIONS } from "@src/utility/constants";
import { ThemeContext } from "@context/theme";
// import DataTableFooter from "react-data-table-component-footer";
import classnames from "classnames";
import { multipleColumnFixedCSS } from "./hooks/use-reorder";
import size from "lodash/size";
import { useLocation } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const PaginationDataTable = (props) => {
    const {
        columns = [],
        loading = true,
        defaultLimit = 10,
        pagination: { page, total, limit = defaultLimit, count = 0 } = {},
        handlePerRowsChange = () => { },
        handlePageChange = () => { },
        data = [],
        fixed = true,
        dense = false,
        conditionalRowStyles,
        getStartedComp = null,
        customNoData = null,
        className = "",
        enableSelect = false,
        handleSelectedRows = () => {},
        expandableRows = false,
        expandableRowsComponent = <></>,
        paginationRowsPerPageOptions = ROW_PER_PAGINATION_OPTIONS,
        showPagination = true,
        handleColumnOrderChange = () => { },
        pagination = {},
        fixedColumns = [],
        sortField,
        sortDirection,
        handleSort,
        ...otherProps
    } = props;

    const CustomPagination = ({
        rowsPerPage,
        rowCount,
        onChangePage,
        onChangeRowsPerPage,
        currentPage
    }) => {
        const handlePageChange = (page) => {
            onChangePage(page);
        };
        return (
            <Paginate
                limit={rowsPerPage}
                paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                handleLimit={onChangeRowsPerPage}
                handlePageChange={handlePageChange}
                currentPage={currentPage}
                count={rowCount} />
        );
    };

    const { getSearchParams } = useSearchParams();

    const noRecordView = () => {
        if (getStartedComp && !total) {
            return getStartedComp;
        }
        if (customNoData) {
            return customNoData;
        }
        return <NoDataComponent />;
    };

    const onColumnOrderChange = (reOrderedColumns) => {
        if (handleColumnOrderChange) {
            handleColumnOrderChange(reOrderedColumns);
        }
    };
    const fixedColumnCSS = multipleColumnFixedCSS(fixedColumns);
    const hasFixedColumns = fixedColumns.length > 0;
    
    const [tempLimit, setTempLimit] = useState();

    useEffect(() => {
        setTempLimit(Number(getSearchParams("limit")) || limit);
    }, [defaultLimit, getSearchParams("limit")]);

    const { filterOpen, handleFilterFocus } = useContext(ThemeContext);
    const { pathname } = useLocation();

    useEffect(() => {
        if (filterOpen) {
            handleFilterFocus();
        }
    }, [pathname]);
    
    return (
        <ErrorBoundaryWrapper name="tables"
            children={ 
                <div
                    data-cy="pagination-datatable"
                    className={classnames({
                        "pagination-dataTable" : size(pagination),
                        [className]            : className,
                        "filter-open"          : filterOpen,
                        "dynamic-fixed-columns": hasFixedColumns 
                    })}>
                    {hasFixedColumns && (
                        <style dangerouslySetInnerHTML={{ __html: fixedColumnCSS }} />
                    )}
                    {tempLimit ? (
                        <DataTable
                            noHeader
                            // persistTableHead
                            pagination={showPagination}
                            columns={(columns.map((item) => {
                                return ({
                                    ...item,
                                    name   : (item.name),
                                    reorder: true,
                                    id     : (item.id || item.name) 
                                });
                            })) }
                            onSort={handleSort}
                            sortDirection={sortDirection}
                            defaultSortField={sortField}
                            responsive={!hasFixedColumns} 
                            paginationPerPage={tempLimit}
                            progressPending={loading}
                            onColumnOrderChange={onColumnOrderChange }
                            paginationComponent={CustomPagination}
                            progressComponent={
                                <div style={{ width: "600px", height: "300px" }}>
                                    <ComponentSpinner />
                                </div>
                            }
                            fixedHeaderScrollHeight={"calc(100vh - 11.5rem)"}
                            className={classnames("react-dataTable", {
                                "fixed-column": fixed,
                                dense,
                                "no-data"     : !size(data),
                                loading
                            })}
                            paginationServer={Boolean(size(pagination))}
                            conditionalRowStyles={conditionalRowStyles}
                            striped
                            {...(enableSelect ? {
                                selectableRows      : true,
                                onSelectedRowsChange: handleSelectedRows
                                // clearSelectedRows   : toggledClearRows
                            } : {})}
                            paginationTotalRows={count}
                            noDataComponent={noRecordView()}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            dense={dense}
                            defaultSortAsc={false}
                            // fixedHeaderScrollHeight={`calc(100vh - ${fixedHeight}rem)`}
                            paginationDefaultPage={page}
                            paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                            fixedHeader
                            {...otherProps}
                            expandableRows={expandableRows}
                            expandableRowsComponent={expandableRowsComponent}
                            expandableRowExpanded={(row) => row.defaultExpanded}
                            data={data} />
                    ) : null}
                </div>
            }/>

    );
};
export default PaginationDataTable;
